export default {
  blank: () => import("/home/runner/work/mfx-framework/mfx-framework/apps/live-preview/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/mfx-framework/mfx-framework/apps/live-preview/layouts/default.vue").then(m => m.default || m)
}